const issue_types = [
  { label: "Zgłoszenie pojedyncze", value: "normal", color: "processing" },
  { label: "Zgłoszenie zbiorcze", value: "master", color: "success" },
  { label: "Podzgłoszenie", value: "subtask", color: "warning" },
];

export const issue_type_options = [
  { label: "Zgłoszenia pojedyncze", value: "0" },
  { label: "Zgłoszenia zbiorcze", value: "1" },
  { label: "Podzgłoszenia", value: "2" },
];

const getIssueType = (type) =>
  issue_types.find(({ value }) => value === type) || {
    label: type,
    value: type,
    color: "default",
  };

export const getIssueTypeOption = (value) => {
  switch (value) {
    case "0":
      return "normal";
    case "1":
      return "master";
    case "2":
      return "subtask";
    default:
      return "normal";
  }
};

export default getIssueType;
